import { takeEvery } from 'redux-saga/effects';
import { load } from 'sdk/billerMask';
import { LOAD } from 'model/billerMask';
import { callAction, ORM } from '../util';

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({ api: load, dataName: ORM, type: LOAD })
  );
}
